import { render, staticRenderFns } from "./ArchivesStatisticst.vue?vue&type=template&id=0e4d629b&scoped=true"
import script from "./ArchivesStatisticst.vue?vue&type=script&lang=js"
export * from "./ArchivesStatisticst.vue?vue&type=script&lang=js"
import style0 from "./ArchivesStatisticst.vue?vue&type=style&index=0&id=0e4d629b&prod&lang=less&scoped=true"
import style1 from "./ArchivesStatisticst.vue?vue&type=style&index=1&id=0e4d629b&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4d629b",
  null
  
)

export default component.exports